import moment from 'moment';
import styles from './style.module.scss';
interface ContentProps {
  title: string;
  author: string;
  date: number;
  htmlContent: string;
}

const StreamLakeContent = (props: ContentProps) => {
  const { title, author, date, htmlContent } = props;
  return (
    <div className={styles['sl-content']}>
      <div className="sl-content-heading-h1">{title}</div>
      <div className="sl-content-inline">
        <div className="sl-content-author">{author}</div>
        <div className="sl-content-date">
          {moment(date).format('YYYY-MM-DD HH:mm')}
        </div>
      </div>
      <div className="sl-content-horizontal-rule"></div>
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </div>
  );
};

export default StreamLakeContent;
